import { api } from './api';
import { TravelBuddy } from '../../types/trip.types';

export type ContactMemberPreviewResponse = {
  found: boolean;
  is_self: boolean;
  first_name: string;
  last_name: string;
  profile_picture: string | null;
};

interface UserResponse {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  username: string;
  gender: string;
  age_group: string;
  country: string;
  nearest_city: string;
  nearest_airport: string;
  chosen_plan: number;
  primary_travel_purposes: string[];
  destination_types: string[];
  activity_interests: string[];
  travel_preference: string;
  budget_preference: string;
  pace_preference: string;
  is_inviting_others: boolean;
  unit_system: string;
  trip_planning_style: string;
  profile_picture: string | null;
}

export const userContacts = api.injectEndpoints({
  endpoints: builder => ({
    getContacts: builder.query({
      query: (params = {}) => {
        const queryParams: Record<string, string> = {};

        if (params.type) queryParams.type = params.type;

        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/`,
          params: Object.keys(queryParams).length > 0 ? queryParams : undefined,
        };
      },
      keepUnusedDataFor: 5,
    }),
    getTravelBuddies: builder.query<TravelBuddy[], void>({
      query: () => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/`,
          params: { type: 'Travel Buddy' },
        };
      },
      keepUnusedDataFor: 5,
    }),
    updateContact: builder.mutation({
      query: ({ email, first_name, id, last_name, phone_number, relationship, type, username }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/${id}/`,
          method: 'PATCH',
          body: {
            email,
            first_name,
            last_name,
            phone_number,
            relationship,
            type,
            username,
          },
        };
      },
    }),
    createContact: builder.mutation({
      query: ({ email, first_name, last_name, phone_number, relationship, type, username }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/`,
          method: 'POST',
          body: {
            email,
            first_name,
            last_name,
            phone_number,
            relationship,
            type,
            username,
          },
        };
      },
    }),
    deleteContact: builder.mutation({
      query: id => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/${id}/`,
          method: 'DELETE',
        };
      },
    }),

    contactMemberPreview: builder.mutation<ContactMemberPreviewResponse, { email: string }>({
      query: body => ({
        url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/member-preview/`,
        method: 'POST',
        body,
      }),
    }),

    uploadAvatar: builder.mutation<UserResponse, File>({
      query: file => {
        const formData = new FormData();
        formData.append('profile_picture', file);

        return {
          url: `${process.env.REACT_APP_API_URL}/users/me/`,
          method: 'PATCH',
          body: formData,
        };
      },
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetContactsQuery,
  useGetTravelBuddiesQuery,
  useUpdateContactMutation,
  useCreateContactMutation,
  useDeleteContactMutation,
  useContactMemberPreviewMutation,
  useUploadAvatarMutation,
} = userContacts;
